export default __webpack_public_path__ + "static/media/LogoKokaBulat.2fad8d1a.png";